import { render } from "./CreateApartment.vue?vue&type=template&id=2bb99c4c"
import script from "./CreateApartment.vue?vue&type=script&lang=js"
export * from "./CreateApartment.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__